// Программа лояльности: 2% от стоимости продукции, 1 бонус = 1 рубль
export const BONUS_ACCRUAL_RATE = 0.02;

export const calcBonusPoints = (price) => {
    const num = Number(price);
    if (!num || num <= 0) return 0;
    return Math.floor(num * BONUS_ACCRUAL_RATE);
};
